import { addColumnPanel as addColumnPanelDef } from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'
import { DESIGN_SYSTEMS } from '@wix/wix-data-client-common-standalone'

export default async (
  { hostname, editorSdkProxy, i18n },
  { fields, componentType, componentRef, boundFields, repeaterAncestorCompRef },
) =>
  editorSdkProxy.editor.openToolPanel({
    url: await getPanelUrl({
      hostname,
      relativeUrl: addColumnPanelDef.url,
      editorSdkProxy,
      params: {
        designSystemsToLoad: [DESIGN_SYSTEMS.WDS, DESIGN_SYSTEMS.BASE_UI],
      },
    }),
    title: i18n.t('Connect_Panel_Connect_Table_Add_Column_Panel_Title'),
    initialData: {
      fields,
      componentType,
      componentRef,
      boundFields,
      repeaterAncestorCompRef,
    },
    width: 240,
    height: 190,
    noPanelPadding: true,
  })
